import React from "react";

function Footer() {
  return (
    <div className="footer">
      <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019">
        <p className="footer-txt">
          &#169; VaxTrail, Stay Safe, Stay Healthy 😷
        </p>
      </a>
    </div>
  );
}

export default Footer;
